import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react'; // @ts-expect-error Could not find a declaration file for module

import HubSpotLanguageSelect from 'ui-addon-i18n/components/HubSpotLanguageSelect';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { FormattedMessage } from '../../../components/I18n';
import { EXPORT_EMAIL_KEY, EXPORT_FORMAT_KEY, EXPORT_LANGUAGE_KEY } from '..';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon'; // @ts-expect-error Could not find a declaration file for module

import createFormField from 'ExportDialog/components/formFields/FormField'; // @ts-expect-error Could not find a declaration file for module

import EmailFieldAndNotificationHelpText from 'ExportDialog/components/formFields/EmailFieldAndNotificationHelpText'; // @ts-expect-error Could not find a declaration file for module

import FormatField from 'ExportDialog/components/formFields/FormatField';
import getLang from 'I18n/utils/getLang';

const LanguageField = ({
  onChange,
  value = getLang()
}) => {
  const handleLanguageChange = useCallback(({
    language: newLanguage
  }) => {
    onChange(newLanguage);
  }, [onChange]);
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(UIHelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.export.languageTip"
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.export.languageHeader"
      })
    }),
    children: /*#__PURE__*/_jsx(HubSpotLanguageSelect, {
      onChange: handleLanguageChange,
      validLanguages: ['ja', 'pt-br', 'de', 'en', 'es', 'fr'],
      value: value
    })
  });
};

export const createExportLanguageFormField = (language = getLang()) => createFormField(LanguageField, EXPORT_LANGUAGE_KEY, language);
export const ExportEmailFormField = createFormField(EmailFieldAndNotificationHelpText, EXPORT_EMAIL_KEY);
export const ExportFormatFormField = createFormField(FormatField, EXPORT_FORMAT_KEY);